var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/followIconWhite.6885bb18.png","uri@2x": __webpack_public_path__ + "static/media/followIconWhite.6885bb18.png","uri@3x": __webpack_public_path__ + "static/media/followIconWhite.0c13341b.png",
    width: 32,
    height: 32
});